var _path, _path2, _path3, _path4, _path5, _path6, _polygon, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoginImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Car--inject-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M209.263,435.584s14.097,0,19.983-.127c7.039-.151,14.168-2.791,19.512-10.999,9.659-14.835,9.659-38.886,0-53.721-4.829-7.417-14.129-11.126-20.458-11.126h-18.851c-9.659,14.835-9.844,61.138-.186,75.973Z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 209.45,
    cy: 397.598,
    rx: 24.733,
    ry: 37.986,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M208.238,378.506v11.938c0,1.027,.542,1.86,1.211,1.86h.008c.669,0,1.211-.833,1.211-1.86v-11.938c0-1.027-.542-1.86-1.211-1.86h-.008c-.669,0-1.211,.833-1.211,1.86Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M208.238,404.746v11.938c0,1.027,.542,1.86,1.211,1.86h.008c.669,0,1.211-.833,1.211-1.86v-11.938c0-1.027-.542-1.86-1.211-1.86h-.008c-.669,0-1.211,.833-1.211,1.86Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M204.826,395.642c.578,.502,1.312,.19,1.639-.699h0c.336-.889,.14-2.027-.438-2.544l-6.734-5.999-.003-.003c-.58-.511-1.32-.204-1.653,.687h0l-.002,.005c-.333,.891-.133,2.027,.447,2.539l6.726,5.999,.017,.015Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M221.269,408.022h0l.002-.005c.333-.891,.133-2.027-.447-2.539l-6.726-5.999c-.58-.518-1.324-.218-1.664,.672h0c-.336,.895-.137,2.038,.445,2.556l6.726,5.999c.582,.516,1.327,.21,1.664-.684Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M197.639,408.075c.335,.889,1.075,1.193,1.654,.679l6.734-5.999c.579-.521,.775-1.664,.438-2.556h0c-.337-.889-1.078-1.189-1.656-.672l-6.726,5.999-.003,.003c-.579,.514-.777,1.652-.442,2.541h0l.002,.005Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M212.44,394.963c.338,.886,1.08,1.184,1.657,.665l6.726-5.999,.003-.003c.579-.514,.777-1.652,.442-2.541h0c-.337-.894-1.081-1.2-1.664-.684l-6.726,5.999-.003,.003c-.579,.514-.777,1.652-.442,2.541h0l.007,.019Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M209.449,394.464h0c-1.126,0-2.039,1.402-2.039,3.132s.913,3.131,2.039,3.131,2.039-1.402,2.039-3.132-.913-3.131-2.039-3.131Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 209.45,
    cy: 397.598,
    rx: 24.733,
    ry: 37.986,
    style: {
      opacity: 0.3
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M284.724,414.055s5.314-58.84-31.404-58.84c0,0-20.091,.231-23.324,27.712-3.233,27.481-1.155,31.128-1.155,31.128h55.883Z",
    style: {
      fill: "#E53935"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.724,414.055s5.314-58.84-31.404-58.84c0,0-20.091,.231-23.324,27.712-3.233,27.481-1.155,31.128-1.155,31.128h55.883Z",
    style: {
      opacity: 0.3
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M116.734,416.399s5.837-62.753-32.553-70.233c0,0-21.653,.265-25.137,31.81-3.484,31.545,11.676,36.985,11.676,36.985l46.014,1.438Z",
    style: {
      fill: "#E53935"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.734,416.399s5.837-62.753-32.553-70.233c0,0-21.653,.265-25.137,31.81-3.484,31.545,11.676,36.985,11.676,36.985l46.014,1.438Z",
    style: {
      opacity: 0.3
    }
  })), /*#__PURE__*/React.createElement("g", null, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M83.125,433.867s13.087,0,18.552-.127c6.535-.151,13.154-2.791,18.115-10.999,8.967-14.835,8.967-38.886,0-53.721-4.483-7.417-13.117-11.126-18.993-11.126h-17.502c-8.967,14.835-9.139,61.138-.172,75.973Z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 83.298,
    cy: 395.88,
    rx: 22.962,
    ry: 37.987,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.173,376.789v11.938c0,1.027,.503,1.86,1.124,1.86h.007c.621,0,1.124-.833,1.124-1.86v-11.938c0-1.027-.503-1.86-1.124-1.86h-.007c-.621,0-1.124,.832-1.124,1.86Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.173,403.029v11.938c0,1.027,.503,1.86,1.124,1.86h.007c.621,0,1.124-.832,1.124-1.86v-11.938c0-1.027-.503-1.86-1.124-1.86h-.007c-.621,0-1.124,.833-1.124,1.86Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.005,393.925c.537,.502,1.218,.19,1.522-.699h0c.312-.889,.13-2.027-.407-2.544l-6.252-5.999-.003-.003c-.538-.512-1.226-.204-1.535,.687h0l-.002,.005c-.309,.891-.123,2.027,.415,2.539l6.245,5.999,.015,.015Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.271,406.305h0l.002-.005c.309-.891,.123-2.027-.415-2.539l-6.245-5.999c-.539-.518-1.23-.218-1.545,.672h0c-.312,.895-.127,2.038,.413,2.556l6.244,5.999c.541,.516,1.232,.21,1.545-.684Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.333,406.357c.311,.889,.998,1.193,1.536,.679l6.252-5.999c.538-.521,.719-1.664,.406-2.556h0c-.312-.889-1.001-1.189-1.537-.672l-6.245,5.999-.003,.003c-.538,.514-.721,1.652-.41,2.541h0l.002,.005Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.075,393.246c.314,.886,1.002,1.184,1.538,.665l6.245-5.999,.003-.003c.538-.514,.721-1.652,.41-2.541h0c-.313-.894-1.004-1.2-1.545-.684l-6.244,5.999-.003,.003c-.538,.514-.721,1.652-.41,2.541h0l.007,.019Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M83.297,392.746h0c-1.045,0-1.893,1.402-1.893,3.132s.848,3.131,1.893,3.131,1.893-1.402,1.893-3.131-.848-3.132-1.893-3.132Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", null, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M254.507,435.584s14.097,0,19.983-.127c7.039-.151,14.168-2.791,19.512-10.999,9.659-14.835,9.659-38.886,0-53.721-4.829-7.417-14.129-11.126-20.458-11.126h-18.851c-9.659,14.835-9.844,61.138-.185,75.973Z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 254.693,
    cy: 397.598,
    rx: 24.733,
    ry: 37.986,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M253.482,378.506v11.938c0,1.027,.542,1.86,1.211,1.86h.008c.669,0,1.211-.833,1.211-1.86v-11.938c0-1.027-.542-1.86-1.211-1.86h-.008c-.669,0-1.211,.833-1.211,1.86Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M253.482,404.746v11.938c0,1.027,.542,1.86,1.211,1.86h.008c.669,0,1.211-.833,1.211-1.86v-11.938c0-1.027-.542-1.86-1.211-1.86h-.008c-.669,0-1.211,.833-1.211,1.86Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M250.069,395.642c.578,.502,1.312,.19,1.639-.699h0c.336-.889,.14-2.027-.438-2.544l-6.734-5.999-.003-.003c-.58-.511-1.32-.204-1.653,.687h0l-.002,.005c-.333,.891-.133,2.027,.447,2.539l6.726,5.999,.017,.015Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M266.512,408.022h0l.002-.005c.333-.891,.133-2.027-.447-2.539l-6.726-5.999c-.58-.518-1.324-.218-1.664,.672h0c-.336,.895-.137,2.038,.445,2.556l6.726,5.999c.582,.516,1.327,.21,1.664-.684Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M242.883,408.075c.335,.889,1.075,1.193,1.654,.679l6.734-5.999c.579-.521,.775-1.664,.437-2.556h0c-.337-.889-1.078-1.189-1.656-.672l-6.726,5.999-.003,.003c-.579,.514-.777,1.652-.442,2.541h0l.002,.005Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M257.684,394.963c.338,.886,1.08,1.184,1.657,.665l6.726-5.999,.003-.003c.579-.514,.777-1.652,.442-2.541h0c-.337-.894-1.082-1.2-1.664-.684l-6.726,5.999-.003,.003c-.579,.514-.777,1.652-.442,2.541h0l.007,.019Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M254.692,394.464h0c-1.126,0-2.039,1.402-2.039,3.132s.913,3.131,2.039,3.131,2.039-1.402,2.039-3.132-.913-3.131-2.039-3.131Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", null, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M409.26,435.584s14.097,0,19.983-.127c7.039-.151,14.168-2.791,19.512-10.999,9.659-14.835,9.659-38.886,0-53.721-4.829-7.417-14.129-11.126-20.458-11.126h-18.851c-9.659,14.835-9.844,61.138-.185,75.973Z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 409.447,
    cy: 397.598,
    rx: 24.733,
    ry: 37.987,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 409.447,
    cy: 397.598,
    rx: 24.733,
    ry: 37.987,
    style: {
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M408.235,378.506v11.938c0,1.027,.542,1.86,1.211,1.86h.008c.669,0,1.211-.833,1.211-1.86v-11.938c0-1.027-.542-1.86-1.211-1.86h-.008c-.669,0-1.211,.833-1.211,1.86Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M408.235,404.746v11.938c0,1.027,.542,1.86,1.211,1.86h.008c.669,0,1.211-.833,1.211-1.86v-11.938c0-1.027-.542-1.86-1.211-1.86h-.008c-.669,0-1.211,.833-1.211,1.86Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M404.822,395.642c.578,.502,1.312,.19,1.639-.699h0c.336-.889,.14-2.027-.438-2.544l-6.734-5.999-.003-.003c-.58-.511-1.32-.204-1.653,.687h0l-.002,.005c-.333,.891-.133,2.027,.447,2.539l6.726,5.999,.017,.015Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M421.265,408.022h0l.002-.005c.333-.891,.133-2.027-.447-2.539l-6.726-5.999c-.58-.518-1.324-.218-1.664,.672h0c-.336,.895-.137,2.038,.445,2.556l6.726,5.999c.583,.516,1.327,.21,1.664-.684Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M397.636,408.075c.335,.889,1.075,1.193,1.654,.679l6.734-5.999c.579-.521,.775-1.664,.437-2.556h0c-.337-.889-1.078-1.189-1.656-.672l-6.726,5.999-.003,.003c-.579,.514-.777,1.652-.442,2.541h0l.002,.005Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M412.437,394.963c.338,.886,1.08,1.184,1.657,.665l6.726-5.999,.003-.003c.579-.514,.777-1.652,.442-2.541h0c-.337-.894-1.081-1.2-1.664-.684l-6.726,5.999-.003,.003c-.579,.514-.777,1.652-.442,2.541h0l.007,.019Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M409.446,394.464h0c-1.126,0-2.039,1.402-2.039,3.132s.913,3.131,2.039,3.131,2.039-1.402,2.039-3.132-.913-3.131-2.039-3.131Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M55.462,348.262c2.122-11.318,5.659-29.71,7.428-31.832s10.964-2.829,10.964-2.829c9.55-10.61,39.967-28.648,55.529-36.43,15.562-7.781,27.588-9.549,86.653-13.086,59.066-3.537,94.08,4.952,94.08,4.952,30.063,3.183,79.933,45.979,79.933,45.979,28.231,5.285,47.394,19.807,47.394,19.807,0,0,15.208,2.122,21.928,9.549,6.72,7.427,7.427,15.916,7.427,15.916,0,0,3.89,0,6.013,3.183,2.122,3.183,1.061,25.112,0,36.076-1.061,10.964-9.549,15.916-9.549,15.916l-171.72-1.05h-.043c-3.637-.022-6.541-3.002-6.512-6.639,.126-15.365-2.6-52.243-31.668-52.243,0,0-20.091,.231-23.324,27.712-2.772,23.563-1.64,29.599-1.261,30.843l-119.159,1.378-.706-.152c.411-7.472,3.495-42.779-14.449-55.664-5.371-3.857-14.641-4.305-20.233-.775-5.656,3.571-12.214,10.902-13.718,25.881-.725,5.734-.729,10.911-.508,17.988l-4.501-2.486c-.707-4.244-2.122-40.674,0-51.992Z",
    style: {
      fill: "#E53935"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.312,356.608c.877,1.169,9.412,13.173,9.412,13.173,2.199,1.17-7.075,7.962-7.075,6.866h-73.041l-19.754-6.749c.673-1.646,8.32-12.413,14.751-13.29,6.431-.877,75.707,0,75.707,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.294,406.361c-.065,0-.12-.05-.125-.116-.016-.216-1.6-21.743-1.933-33.78-.062-2.267-.303-7.254-.581-13.028-.591-12.268-1.401-29.069-1.169-33.536,.34-6.545,7.389-11.419,7.46-11.468,.057-.039,.135-.023,.174,.033,.039,.057,.024,.135-.033,.174-.07,.048-7.018,4.854-7.351,11.274-.231,4.453,.578,21.248,1.168,33.511,.278,5.775,.519,10.764,.582,13.032,.333,12.032,1.916,33.554,1.932,33.771,.005,.068-.046,.128-.115,.134h-.009Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.32,409.208h-.005l-108.729-4.419c-.062-.003-.112-.05-.119-.11l-1.897-16.488c-4.905-23.059-14.246-30.497-19.265-34.493-1.52-1.21-2.619-2.085-2.964-2.967-1.395-3.562-3.198-31.799-2.818-35.596,.264-2.636,7.709-8.196,12.157-11.519,1.522-1.137,2.724-2.034,3.037-2.373,.046-.05,.126-.054,.177-.007,.051,.047,.054,.126,.007,.177-.328,.355-1.479,1.215-3.071,2.403-4.415,3.298-11.805,8.816-12.058,11.344-.365,3.645,1.473,32.088,2.801,35.479,.321,.82,1.397,1.678,2.887,2.863,5.043,4.016,14.43,11.49,19.355,34.647l1.887,16.395,108.529,4.41c.158-.953,.003-10.155-.175-20.761-.369-21.966-.875-52.048,.289-57.412,2.299-10.6,11.841-13.819,11.937-13.851,.066-.02,.136,.015,.157,.08,.021,.066-.014,.137-.08,.158-.095,.03-9.501,3.209-11.77,13.665-1.157,5.336-.631,36.641-.283,57.354,.301,17.912,.312,20.856,.079,21.001-.02,.012-.042,.019-.066,.019Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.608,313.996H249.56s-33.092-31.061-42.672-40.93c11.987-1.795,82.551-3.096,104.212,0,0,0,37.156,6.677,68.507,40.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.704,313.996s-34.488-34.996-41.588-38.039c-7.1-3.043-30.937-1.268-40.574,0-9.636,1.268-44.647,16.497-50.733,25.372,0,0,5.595,8.101,15.485,10.637,9.89,2.536,7.354,.762,28.148,2.03,20.794,1.268,89.262,3.295,89.262,3.295v-3.295Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.312,356.732h-.017c-.068-.01-.116-.073-.107-.142,1.436-10.907-12.678-21.876-12.82-21.985-.055-.042-.065-.121-.023-.176,.043-.056,.122-.064,.176-.023,.144,.11,14.37,11.166,12.916,22.218-.009,.062-.062,.108-.124,.108Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.799,359.972c-.834,1.158-1.493,7.637-7.574,7.692l-6.577-8.128s2.975-12.593,1.112-19.745c0,0,5.917,3.707,8.082,7.41,2.164,3.704,4.957,12.771,4.957,12.771Z",
    style: {
      fill: "#fff",
      opacity: 0.7
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.267,337.791s-10.239-10.25-48.2-18.058l-16.363-2.442c-2.869,.194-5.815,2.356-8.806,5.706-12.252,2.39-91.538-4.102-91.538-4.102,0,0,81.214,6.345,105.636,7.948,24.422,1.602,23.795,1.71,59.272,10.948Z",
    style: {
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.516,319.891c.25-.137,8.741,1.131,14.447,2.6,0,0-11.224,12.577-14.957,13.182l-2.997-.567s.516-13.577,3.508-15.215Z",
    style: {
      fill: "#d7504d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.478,343.055c-.018,0-.036-.004-.054-.012-.062-.03-.089-.104-.06-.167,.004-.007,.353-.774-.089-1.804-.428-.998-1.693-2.438-5.293-3.639-2.144-.714-7.035-1.938-12.699-3.354-12.933-3.235-30.646-7.667-32.093-10.146-2.03-3.482-3.734-9.843-3.751-9.906-.018-.066,.022-.136,.088-.153,.068-.018,.136,.022,.153,.089,.017,.063,1.712,6.392,3.727,9.845,1.394,2.388,19.047,6.804,31.937,10.029,5.669,1.418,10.565,2.643,12.717,3.36,2.968,.988,4.801,2.263,5.448,3.785,.482,1.134,.099,1.966,.082,2.001-.021,.045-.066,.071-.113,.071Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.475,401.39s-99.041-1.389-100.308-3.288c-1.266-1.899,7.25-7.644,7.25-7.644,1.266-.874,92.422,5.401,93.058,10.932Z",
    style: {
      fill: "#fff",
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 419.153,
    cy: 357.257,
    rx: 9.434,
    ry: 4.021,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.592,397.22s7.69,3.599,7.389,3.612c-.301,.014-1.803,7.829-1.803,7.829l-118.1-1.632-11.124-9.431,35.462-.486,88.177,.108Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.212,397.595c.362,.608,11.126,0,11.126,0l10.895,9.197-16.017-.374-6.004-8.823Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.487,357.382h-.013l-12.894-1.359c-.069-.007-.119-.068-.111-.137,.007-.068,.071-.131,.137-.111l12.894,1.358c.069,.007,.119,.068,.111,.137-.007,.064-.061,.112-.124,.112Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.594,355.224s-63.444-14.256-68.346-13.765-18.464,4.459-17.481,8.146c.983,3.687,11.35,9.306,25.115,11.518,10.964,1.762,28.758,3.933,40.556,4.67,14.399,.9,20.155-10.569,20.155-10.569Z",
    style: {
      fill: "#fff",
      opacity: 0.7
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.752,381.902s-24.161-11.79-33.493-11.79-50.959-12.218-50.959-12.218c0,0,31.144,19.722,38.032,21.36,6.888,1.639,46.42,2.647,46.42,2.647Z",
    style: {
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.242,311.246s-35.124-31.884-64.438-34.857-47.608-2.113-47.608-2.113c0,0,8.709,22.326,24.797,26.744,16.087,4.418,87.25,10.226,87.25,10.226Z",
    style: {
      fill: "#fff",
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.597,365.844s.832,6.295-.694,9.208c-1.526,2.914-15.678,6.775-15.678,6.775l16.372-15.984Z",
    style: {
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.799,353.341c0,3.923,4.263,7.103,9.522,7.103s9.522-3.18,9.522-7.103-4.263-7.102-9.522-7.102-9.522,3.18-9.522,7.102Z",
    style: {
      fill: "#fff",
      opacity: 0.7
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.918,345.691l-13.669-1.35s-4.072,8.525,4.027,13.519c0,0-9.984-2.943-6.943-13.519,.193-.932,.617-1.893,2.915-1.411,.743,.156,13.67,2.761,13.67,2.761Z",
    style: {
      fill: "#fff",
      opacity: 0.7
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.974,315.774s52.59,8.607,61.956,34.557c0,0-135.193-33.625-134.608-34.557,.585-.932,72.653,0,72.653,0Z",
    style: {
      fill: "#fff",
      opacity: 0.3
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M234.829,317.42l-.129-.004c-.685-.021-68.708-2.042-89.266-3.296-8.57-.522-13.235-.528-16.322-.532-4.505-.006-6.022-.007-11.85-1.501-9.822-2.519-15.5-10.606-15.557-10.688l-.049-.071,.049-.07c6.116-8.919,40.996-24.133,50.82-25.426,9.736-1.28,33.486-3.055,40.639,.009,7.041,3.019,41.283,37.717,41.627,38.066l.036,.037v3.476Zm-132.867-16.093c.579,.798,6.121,8.147,15.364,10.518,5.796,1.486,7.306,1.487,11.788,1.493,3.089,.004,7.759,.01,16.337,.532,20.127,1.229,85.77,3.192,89.129,3.292v-3.115c-1.292-1.31-34.617-35.021-41.512-37.976-7.104-3.044-30.792-1.27-40.508,.009-9.769,1.286-44.371,16.358-50.597,25.247Z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 155.127,
    y: 332.424,
    width: 16.96,
    height: 6.497,
    rx: 2.172,
    ry: 2.172,
    transform: "translate(26.962 -11.849) rotate(4.52)",
    style: {
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.406,
    y: 325.936,
    width: 16.96,
    height: 6.497,
    rx: 2.172,
    ry: 2.172,
    transform: "translate(26.262 -7.084) rotate(4.52)",
    style: {
      opacity: 0.3
    }
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M160.462,275.118c-.647,.055-8.168,39.418-8.168,39.418h10.902l5.06-39.967s-7.147,.494-7.794,.549Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "223.14 302.49 217.287 316.462 234.704 317.291 234.704 313.698 223.14 302.49"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M198.165,306.768c.09-.123,.183-.249,.277-.379,2.274-3.127,12.367-7.108,22.034-3.838,7.053,2.386,5.781,10.673,4.578,14.981-.578,2.068-2.309,3.597-4.434,3.908-5.784,.846-16.465,.014-19.193-1.404-.147-.076-.292-.155-.434-.234-4.669-2.614-5.998-8.722-2.828-13.034Z",
    style: {
      fill: "#E53935"
    }
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M214.988,321.9c-5.419,0-11.604-.705-13.618-1.753-.148-.077-.294-.156-.438-.236-2.258-1.265-3.868-3.439-4.416-5.968-.547-2.524,.018-5.167,1.548-7.249l.276-.379c2.343-3.221,12.542-7.142,22.175-3.883,7.063,2.389,5.951,10.507,4.659,15.133-.59,2.112-2.371,3.683-4.537,3.999-1.58,.23-3.559,.336-5.65,.336Zm-2.138-20.447c-6.76,0-12.618,2.687-14.307,5.01l-.277,.38h0c-1.488,2.024-2.037,4.593-1.505,7.048,.533,2.458,2.098,4.573,4.294,5.802,.141,.08,.285,.157,.431,.232,2.761,1.437,13.479,2.218,19.117,1.392,2.068-.302,3.769-1.801,4.332-3.817,1.268-4.542,2.37-12.507-4.498-14.83-2.543-.859-5.125-1.216-7.586-1.216Zm-14.685,5.315h0Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M221.674,305.116s-2.37-1.831-6.572-2.047-15.195,.626-16.699,6.822c-1.504,6.195,28.524-2.855,23.27-4.775Z",
    style: {
      fill: "#fff",
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M112.53,283.001c-.169,0-.333-.085-.428-.24-.144-.236-.068-.544,.167-.687,13.148-7.996,24.99-12.907,38.397-15.925,.271-.058,.537,.109,.598,.379,.061,.269-.108,.536-.378,.598-13.296,2.992-25.046,7.866-38.097,15.802-.081,.05-.171,.073-.259,.073Z",
    style: {
      fill: "#E53935"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.79,265.589c-.245,0-.458-.18-.495-.429-.039-.273,.15-.526,.424-.566l6.417-.926c.271-.037,.526,.15,.566,.424,.039,.273-.15,.526-.424,.566l-6.417,.926c-.024,.003-.048,.005-.072,.005Z",
    style: {
      fill: "#E53935"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Lines--inject-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M161.475,355.641h-28.356c-.138,0-.25-.112-.25-.25s.112-.25,.25-.25h28.356c.138,0,.25,.112,.25,.25s-.112,.25-.25,.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.556,362.136h-12.918c-.138,0-.25-.112-.25-.25s.112-.25,.25-.25h12.918c.138,0,.25,.112,.25,.25s-.112,.25-.25,.25Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M317.907,254.093h-29.02c-.138,0-.25-.112-.25-.25s.112-.25,.25-.25h29.02c.138,0,.25,.112,.25,.25s-.112,.25-.25,.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.641,258.657h-34.532c-.138,0-.25-.112-.25-.25s.112-.25,.25-.25h34.532c.138,0,.25,.112,.25,.25s-.112,.25-.25,.25Z",
    style: {
      fill: "#263238"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginImg);
export default __webpack_public_path__ + "static/media/login-img.dea4a8dc826d08ecadef1031ad3a268f.svg";
export { ForwardRef as ReactComponent };